// extracted by mini-css-extract-plugin
module.exports = {"carouseTitle":"ne","icon":"nf","emblaSlide":"nh"};